import React, { useState } from 'react';
import Toolbar, { Item } from 'devextreme-react/toolbar';
import Button from 'devextreme-react/button';
import { Template } from 'devextreme-react/core/template';
import { UserPanel } from '../user-panel/UserPanel';
import { ThemeSwitcher } from '../theme-switcher/ThemeSwitcher';
import type { AppHeaderProps } from '../../../types';
import './AppHeader.scss';
import { LanguageSelect } from '../language/select';
import { getFirmName, getImageURL, getVendorId } from '../../../api/sessions';
import logo from "../../../assets/mobiRoute.png"
 
export const AppHeader = ({ menuToggleEnabled, title, toggleMenu, className }: AppHeaderProps) => {
 
 
  return (
    <header className={`header-component ${className} pt-2`}>
      <Toolbar className='header-toolbar'>
        <Item visible={menuToggleEnabled} location='before' widget='dxButton' cssClass='menu-button'>
          <Button icon='menu' stylingMode='text' onClick={toggleMenu} />
        </Item>
        <Item location='before' cssClass='header-title'>
          <img src={logo} className='w-44'></img>
        </Item>
 
 
        <Item location="after" locateInMenu='auto'>
          <div className='text-right mr-2.5 '>
            <div>{getFirmName()}</div>
            <div style={{ fontSize: 11 }}>{getVendorId()}</div>
          </div>
        </Item>
 
        <Item location="after" locateInMenu="auto">
          <div className="flex items-center justify-center w-[30px] h-[30px]">
            <img
              src={getImageURL()+"/logo/logo_3.png"}
              className="w-[30px] h-[30px] object-contain"
            />
          </div>
        </Item>
 
 
        <Item location='after' locateInMenu='auto'>
          <div className='separator' />
        </Item>
 
        <Item location='after' locateInMenu='never'>
          <ThemeSwitcher />
        </Item>
        <Item location='after'>
          <LanguageSelect />
        </Item>
 
        <Item location='after' locateInMenu='auto' menuItemTemplate='userPanelTemplate'>
          <UserPanel menuMode='context' />
        </Item>
        <Template name='userPanelTemplate'>
          <UserPanel menuMode='list' />
        </Template>
      </Toolbar>
    </header>
  );
};
 
 